import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort, useActions } from "@nosto/preact"
import { sortOptions } from "../config"
import Sidebar from "./Sidebar"
import Icon from "./elements/Icon"
import SelectedFilters from "./SelectedFilters"
import Select from "./elements/Select"
import { useState } from "preact/hooks"
import { options } from "preact"


export default function Toolbar({ mobile, onToggleSidebar }) {
  const { loading, query, response, pageType } = useAppState()
  const { activeSort, setSort } = useSort(sortOptions)
  const selectedFiltersCount = useSelectedFiltersCount()
  const { updateSearch } = useActions()

  const handleSortChange = event => {
    setSort(event.target.value)
  }

  const docCount = response.products?.total ?? 0

  const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

  const activeSortIndex = sortOptions.indexOf(sortOptions.find(option => option.id === activeSort))

  const [sortIsActive, setSortIsActive] = useState(false)

  const toggleSortIsActive = () => {
    setSortIsActive(!sortIsActive)
  }

  if (sortIsActive) {
    document.addEventListener("click", function (event) {
      if (!event.target.closest('.ns-category-select-label')) {
        toggleSortIsActive()
      }
    });
  }

  const [selectedValue, setSelectedValue] = useState(sortOptions[0].id);
  const [firstOptionSelected, setFirstOptionSelected] = useState(true);
  const handleSortOptionClick = (clickedId, index) => {
    setSelectedValue(clickedId);
    if (index !== 0) {
      setFirstOptionSelected(false);
    }
    const clickedSort = sortOptions.find(sort => sort.id === clickedId);
    if (clickedSort) {

      updateSearch({
        products: {
          sort: clickedSort.value.sort
        },
      });
    }
  };


  return (
    <div
      class="ns-toolbar-wrap"
      style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
    >
      <div
        class="ns-toolbar-actions"
      >
        <button
          onClick={onToggleSidebar}
          class="ns-toggle-sidebar-btn">
          Filters
          {selectedFiltersCount > 0 && (
            <span> &nbsp;({selectedFiltersCount})</span>
          )}
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4.5L6 7.5L9 4.5" stroke="#000017" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
        {/* <Select
          value={activeSort}
          onChange={e => handleSortChange(e)}
          className="ns-selection-dropdown-sort-menu"
          options={options}
        /> */}

        <div class="ns-category-select-wrapper">
          <span class="ns-category-select-label" onClick={toggleSortIsActive}> Sort by
            <svg
              class={sortIsActive ? "ns-sort-active-icon" : ""}
              width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="#000017" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </span>
          {sortIsActive && (
            <div class="ns-category-select-list">
              {sortOptions.map((sort, index) => (
                <span
                  key={sort.id}
                  class="ns-category-list-option"
                  onClick={() => handleSortOptionClick(sort.id, index)}
                >
                  {sort.value.name}
                </span>
              ))}
            </div>
          )

          }
        </div>
      </div>
      <SelectedFilters />
    </div>
  )
}
